import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Phone, Calendar } from "lucide-react";
import { Link } from "react-router-dom";

interface StickyCTAProps {
  companyName: string;
  companyColor: string;
  cityName?: string;
  practiceCount?: number;
}

const StickyCTA = ({ companyName, companyColor, cityName, practiceCount }: StickyCTAProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      // Auf Mobile früher zeigen (30%), auf Desktop bei 50%
      const threshold = window.innerWidth < 768 ? 30 : 50;
      setIsVisible(scrollPercentage > threshold);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 border-t shadow-lg animate-slide-in-bottom"
      style={{ 
        backgroundColor: 'hsl(var(--background))',
        borderColor: companyColor
      }}
    >
      <div className="container mx-auto px-4 py-4 sm:py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <div className="text-center sm:text-left w-full sm:w-auto">
            <p className="text-sm sm:text-base font-bold">
              {companyName} Cyberversicherung
            </p>
            {cityName && practiceCount ? (
              <p className="text-xs sm:text-sm text-muted-foreground hidden sm:block">
                Jetzt {practiceCount}+ Praxen in {cityName} geschützt
              </p>
            ) : (
              <p className="text-xs sm:text-sm text-muted-foreground hidden sm:block">
                Jetzt beraten lassen und absichern
              </p>
            )}
          </div>
          <div className="flex gap-3 sm:gap-3 w-full sm:w-auto">
            <Button 
              size="sm"
              variant="outline"
              className="flex-1 sm:flex-none gap-2 min-h-[56px] hover-scale transition-all duration-300"
              asChild
            >
              <a href="tel:+4917670790268">
                <Phone className="w-5 h-5" />
                <span className="text-sm sm:text-sm font-medium">Anrufen</span>
              </a>
            </Button>
            <Button 
              size="sm"
              variant="outline"
              className="flex-1 sm:flex-none gap-2 min-h-[56px] hover-scale transition-all duration-300"
              asChild
            >
              <Link to="/termin-buchen">
                <Calendar className="w-5 h-5" />
                <span className="text-sm sm:text-sm font-medium">Termin buchen</span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyCTA;
